<template>
<div class="smart-filter" :class="drawer?'smart-filter-active':''">

    <div class="flex-container">
        <div class="smart-filter-header">
            <div class="filter-title">
                <v-btn icon small class="mr-1" @click="closeFilter"><v-icon>mdi-chevron-left</v-icon></v-btn>
                Filter {{$route.meta.title || $route.name}}</div>
            <v-autocomplete outlined dense :items="computedFilterProperties" item-text="label" item-value="id" hide-details
                            ref="property-field" placeholder="Choose a Property" @change="onSelectProperty">
                <template v-slot:item="{item}">
                    <v-list-item-content><v-list-item-title class="fs-16" v-html="item.label"/></v-list-item-content>
                </template>
            </v-autocomplete>
        </div>
        <div class="smart-filter-content">
            <v-form ref="form">
            <div class="smart-filter-box" v-for="(v, index) in vFilterValues" :key="'sm-box-'+index">
                <v-btn icon small class="sm-close-btn" @click="removeFilterValue(index)" v-if="!filterPropertiesJson[v.id].persistent">
                    <v-icon small>mdi-close</v-icon></v-btn>
                <div class="sm-field-label">{{filterPropertiesJson[v.id].label}}</div>

                <template v-if="filterPropertiesJson[v.id].type === 'select'">
                <v-autocomplete outlined dense :items="filterPropertiesJson[v.id].options" placeholder="Select Option"
                                v-model="v.value" item-text="text" item-value="value"
                                :rules="validate?[val => !!val || ('Select '+filterPropertiesJson[v.id].label)]:[]">
                    <template v-slot:item="{item}">
                        <v-list-item-avatar v-if="item.hasOwnProperty('icon') || item.hasOwnProperty('image')">
                            <template v-if="item.hasOwnProperty('icon')">
                            <v-icon :class="item.class" :color="item.color">mdi-{{ item.icon }}</v-icon>
                            </template>
                            <template v-if="item.hasOwnProperty('image')">
                                <img :src="imgWpx(item.image, 200)" v-if="item.image" @error="item.image = null">
                                <v-icon size="50" color="blue-grey lighten-5" v-else>mdi-account-circle</v-icon>
                            </template>
                        </v-list-item-avatar>
                        <v-list-item-content><v-list-item-title v-html="item.text"/></v-list-item-content>
                    </template>
                </v-autocomplete>
                </template>
                <template v-if="filterPropertiesJson[v.id].type === 'multiSelect'">
                <v-autocomplete outlined dense :items="filterPropertiesJson[v.id].options" placeholder="Select Option"
                                v-model="v.value" item-text="text" item-value="value" multiple chips deletable-chips class="multi-select-field"
                                :rules="validate?[val => !!(val&&val.length) || ('Select '+filterPropertiesJson[v.id].label)]:[]">
                </v-autocomplete>
                </template>
                <template v-if="filterPropertiesJson[v.id].type === 'date'">
                    <datePicker @date="v.value.startDate=$event.startDate;v.value.endDate=$event.endDate"
                                :initial="{startDate:v.value.startDate, endDate:v.value.endDate}"
                                @isLastNDays="v.value.isLastNDays=$event" :appendToBody="true" opens="right"/>
                </template>
                <template v-if="filterPropertiesJson[v.id].type === 'text'">
                    <v-text-field outlined dense placeholder="Search" v-model="v.value"
                                    :rules="validate?[val => !!val || ('Enter a valid text')]:[]"/>
                </template>

            </div>
            </v-form>
        </div>
        <div class="smart-filter-footer">
            <v-btn rounded depressed @click="applyFilter" :disabled="!vFilterValues.length" class="text-capitalize primary mr-2">Apply Filter</v-btn>
            <v-btn rounded outlined @click="clearFilter" v-if="vFilterValues.length" class="text-capitalize">Clear Filter</v-btn>
            <v-btn rounded outlined @click="closeFilter" v-else class="text-capitalize">Close</v-btn>
        </div>
    </div>
    <Snackbar :toaster="toaster"></Snackbar>

</div>
</template>

<script>
/**
 * filterProperties {array}      -- filterPropertiesJson as Object-version --
 * filterValues {array}          -- filterValuesJson as Object-version --
 */
/* TODO:  operators based on inputType */

import {convertArrToJSON} from "../../util/helpers";
import Vue from 'vue';
import DatePicker from "../Common/datePicker";
import Snackbar from '../Common/Snackbar';
export default {
    name: "SmartFilter",
    components: {DatePicker, Snackbar},
    props: {
        drawer: {type: Boolean},
        filterProperties: {type: Array},
        filterValues: {type: Array},
    },
    data(){
        return{
            vFilterValues: JSON.parse(JSON.stringify(this.filterValues)),                    //Varying
            validate: false,
            toaster: { enable: false, color: 'green', message: '' }
        }
    },
    computed:{
      computedFilterProperties: function(){
          let scalarFilterValues = this.vFilterValues.map(v => v.id)
          return this.filterProperties.filter(p => !scalarFilterValues.includes(p.id))
      },
      filterPropertiesJson: function(){
        return convertArrToJSON(this.filterProperties, 'id')
      }
    },
    watch:{
      drawer: function(val){
          if(val) this.vFilterValues = JSON.parse(JSON.stringify(this.filterValues))
      }
    },
    methods:{
        onSelectProperty(val){
          this.vFilterValues.push({id:val, value:''})
          this.$refs['property-field'].reset()
        },
        removeFilterValue(index){
            this.vFilterValues.splice(index, 1)
            if(!this.vFilterValues.length) this.clearFilter()          //No Need (Extra) - For Persistent Properties(Refactor)
        },
        async applyFilter(){
            let data = this.vFilterValues;
            const isStarCityFilter = this.vFilterValues.some(f => f.id === 'starCity'); 
            const isCityFilter = this.vFilterValues.some(f => f.id === 'city'); 
            if (isStarCityFilter && isCityFilter) {
                data = this.vFilterValues.filter(f => f.id !== 'starCity');
                this.toaster = {
                    color: 'red',
                    enable: true,
                    message: "Please Select only one filter from Star City and City",
                };
            }
            this.vFilterValues = data
          this.validate = true;
          await Vue.nextTick();
          if(this.$refs.form.validate()){
              this.$emit('updateValues', this.vFilterValues)
              // this.closeDrawer()
          }
        },
        clearFilter(){
            this.vFilterValues = []
            this.$emit('updateValues', [])
        },
        closeFilter(){
          this.closeDrawer()
          this.vFilterValues = JSON.parse(JSON.stringify(this.filterValues))         //Reset value
        },
        closeDrawer(){
            this.$emit('update:drawer', false)
            this.validate = false
        }
    }
}
</script>

<style scoped>
.fs-16{
    font-size: 16px !important;
}
.smart-filter{
    width: 0px;
    opacity: 0;
    transition: width 0.2s cubic-bezier(0.22, 0.61, 0.36, 1) 0s;
    overflow: hidden;
    border-right: 1px solid rgb(220, 225, 230);
    /*position: fixed;*/
    /*top: 64px;        !* equal to top-bar height *!*/
    /*left: 56px;       !* equal to navigation-drawer width *!*/
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0px;
}
.smart-filter-active{
    opacity: 1;
    width: 330px;
    min-width: 150px;
    background: rgb(255, 255, 255);
    max-height: calc(100vh - 64px);
}
.flex-container{
    display: flex;
    flex-direction: column;
    height: 100%;
}
.smart-filter-header{
    border-bottom: 1px solid rgb(246, 244, 242);
    position: relative;
    padding: 15px 20px 12px 20px;
    box-shadow: rgba(0, 0, 0, 0.03) 0px 1px 1px;
}
.smart-filter-content{
    flex-grow: 1;
    height: inherit;
    overflow: auto;
    transition: all 0.5s ease 0s;
}
.smart-filter-footer{
    padding: 15px 30px;
    box-shadow: rgba(0, 0, 0, 0.05) 0px -1px 5px 0px;
    position: relative;
}
.filter-title{
    padding: 6px 0 4px 0;
    font-weight: 600;
    margin: 0 0 0 -6px;
}
.smart-filter-box {
    border-bottom: 1px solid #f0f5f8;
    position: relative;
    padding: 13px 20px 8px;
    animation: 1s linear highlightBox-blinker;
}
.smart-filter-box:hover{
    background: #f5f8fa;
}
.smart-filter-box:hover .sm-close-btn{
    transform: scale(1);
}
.smart-filter-box .sm-close-btn{
    position: absolute;
    right: 10px;
    top: 5px;
    visibility: visible;
    transform: scale(0);
    transition: .2s;
    cursor: pointer;
}
.smart-filter-box .sm-field-label{
    font-size: 14px;
    margin: 0 0 6px 0;
}
@keyframes highlightBox-blinker{
    50%{background-color:#f5f8fa}
}
/* Star Icon color */
.dark-yellow {
    color: #f9a825 !important;
}
/* -------------- */
/* ----multiSelect type----*/
/deep/ .multi-select-field .v-chip--select{
    margin: 0 0 4px 2px !important;
    font-size: 12px;
}
/* -------x--------x------ */
</style>